module.exports = __webpack_public_path__ + "static/media/F-Triads.5c5a22b1.png";